import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { ref, watch, onMounted } from 'vue';
import appuserapi from '@/api/appuserapi';
import { useAppUserStore } from '@/stores/appUser';


export default /*@__PURE__*/_defineComponent({
  __name: 'editAppUserPreferences',
  props: {
  title: {
    type: String,
    required: true,
  },
  referenceTextType: {
    type: String,
    required: true,
  },
  dtoKey: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const appUserStore = useAppUserStore()

const preferenceText = ref("")
const focusRef = ref(null);

const props = __props

async function updatePreferenceText() {
  if (!appUserStore.currentAppUserData) return
  const oldText = getPreferenceText()
  const newText = preferenceText.value
  if (oldText === newText) return
  //Update frontend
  appUserStore.currentAppUserData.preferences[props.dtoKey] = newText;
  //Update backend
  await appuserapi.updateReferenceText(props.referenceTextType, newText)
  await appUserStore.setCurrentAppUserData()
}

function setPreferenceText() {
  if (!appUserStore.currentAppUserData) return
  preferenceText.value = getPreferenceText()
}

function getPreferenceText() {
  return appUserStore.currentAppUserData.preferences[props.dtoKey]
}


watch(
  () => appUserStore.currentAppUserData,
  () => {setPreferenceText()},
  { immediate: true }
)

onMounted(() => {
  if (!focusRef.value) return;
  focusRef.value.innerRef.focus()
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"margin":"1rem","padding":"1rem","min-width":"30rem"},
    class: "bg-modal",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_text_item, {
      txt: props.title,
      class: "pad-m w-maxC",
      styles: "font-l"
    }, null, 8, ["txt"]),
    (_unref(appUserStore).currentAppUserData)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mtop-04" }, null, -1)),
          _createVNode(_component_inputBox, null, {
            default: _withCtx(() => [
              _createVNode(_component_inputAreaAuto2, {
                lines: 20,
                ref_key: "focusRef",
                ref: focusRef,
                modelValue: preferenceText.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((preferenceText).value = $event)),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (updatePreferenceText()))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mtop-10" }, null, -1))
  ]))
}
}

})